/**
 * Created by ChrisMuto on 7/18/17.
 */
import * as AuthEvents from "./authentication-events";
import * as DashboardEvents from "./dashboard-events";
import * as ConfigureProjectEvents from "./configure-wevo-events";
import * as ResultsEvents from "./results-events";

export { AuthEvents, DashboardEvents, ConfigureProjectEvents, ResultsEvents };



// WEBPACK FOOTER //
// ./src/modules/tracker/event-names/index.js